export type ControlVariant = 'vrc720'|'vrc720f'|'AI'|'ecoTEC exclusive'|'ecoTEC plus'|'ThemaFast'|'ThemaCondens'|'ThemaMCondens'|'ThemaPlus'|'ThemaFastCondens'|'ThemaFastMCondens'|'ThemaPlusCondens'|'IsoMax'|'IsoMaxCondens'|'IsoTwin'|'IsoFast'|'IsoFastCondens'|'IsoTwinCondens'|'IsoTwinMCondens'|'MasterCondens'|'N/A';
export function ControlVariantFromString(str:string):ControlVariant{
	switch(str){
		case 'vrc720':
			return 'vrc720';
		case 'vrc720f':
			return 'vrc720f';
		case 'AI':
			return 'AI';
		case 'ecoTEC exclusive':
			return 'ecoTEC exclusive';
		case 'ecoTEC plus':
			return 'ecoTEC plus';
		case 'ThemaCondens':
			return 'ThemaCondens';
		case 'ThemaMCondens':
			return 'ThemaMCondens';
		case 'ThemaFastCondens':
			return 'ThemaFastCondens';
		case 'ThemaFastMCondens':
			return 'ThemaFastMCondens';
		case 'ThemaPlusCondens':
			return 'ThemaPlusCondens';
		case 'IsoMaxCondens':
			return 'IsoMaxCondens';
		case 'IsoFastCondens':
			return 'IsoFastCondens';
		case 'IsoTwinCondens':
			return 'IsoTwinCondens';
		case 'IsoTwinMCondens':
			return 'IsoTwinMCondens';
		case 'MasterCondens':
			return 'MasterCondens';
		case 'ThemaFast':
			return 'ThemaFast';
		case 'ThemaPlus':
			return 'ThemaPlus';
		case 'IsoMax':
			return 'IsoMax';
		case 'IsoTwin':
		 	return 'IsoTwin';
	 	case 'IsoFast':
	 		return 'IsoFast';
 		case 'ThemaCondens':
 			return 'ThemaCondens';
		case 'IsoMaxCondens':
 			return 'IsoMaxCondens';
		case 'MasterCondens':
			return 'MasterCondens'; 
		default: 'N/A';
	}
}